var whdef = 100/1920;
var wH = window.innerHeight;
var wW = window.innerWidth;
var rem
if(wW<=1024){
  rem = 1024*whdef;
}else{
  rem = wW * whdef;
}
jq('html').css('font-size',rem+"px");
jq(window).resize(function(){
  var whdef = 100/1920;
  var wH = window.innerHeight;
  var wW = window.innerWidth;
  var rem
  if(wW<=1024){
    rem = 1024*whdef;
  }else{
    rem = wW * whdef;
  }
  jq('html').css('font-size',rem+"px");
})


// WEBPACK FOOTER //
// ./src/assets/js/rem.js